// Copyright ©️ 2026 eVolve MEP, LLC

import { useMemo } from 'react';

import type { ProductId } from '@evolvemep/api-ts';

import { useEvolveGetWithLocalStorage } from 'hooks/useEvolveGetWithLocalStorage';

/**
 * Use this hook when you need to look up if the company has a given license,
 * but not necessarily if this user has been assigned that license.
 * For example, you can use this to check if the user's company has an Electrical or Mechanical license.
 */
export const useProductPoolLicenseCheck = () => {
  const { data: licenseData, loading: loadingProductPools } = useEvolveGetWithLocalStorage('admin/company/licenses', {
    requireLicense: null,
  });

  const productPoolsActive = useMemo(
    () =>
      new Set<ProductId>(
        licenseData?.purchasedProducts
          .filter((p) => p.status !== 'Expired')
          .map((productPool) => productPool.productId) ?? [],
      ),
    [licenseData],
  );
  return { loadingProductPools, productPoolsActive };
};
